export default function getResource(label) {
    const resources = { playVideo: 'Faire jouer la vidéo' };

    return resources[label];
}
